"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ClearButton = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var clear_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/clear.icon.svg"));
var ClearButton_module_scss_1 = __importDefault(require("./ClearButton.module.scss"));
/**
 * @deprecated Please use the same component from `@kaizen/components`
 */
var ClearButton = function (_a) {
    var classNameOverride = _a.classNameOverride, _b = _a.isReversed, isReversed = _b === void 0 ? false : _b, restProps = __rest(_a, ["classNameOverride", "isReversed"]);
    return (react_1["default"].createElement("button", __assign({ type: "button", "aria-label": "clear", className: (0, classnames_1["default"])(ClearButton_module_scss_1["default"].clearButton, isReversed ? ClearButton_module_scss_1["default"].reversed : ClearButton_module_scss_1["default"]["default"], classNameOverride) }, restProps),
        react_1["default"].createElement(component_library_1.Icon, { icon: clear_icon_svg_1["default"], role: "presentation" })));
};
exports.ClearButton = ClearButton;
exports.ClearButton.displayName = "ClearButton";
//# sourceMappingURL=ClearButton.js.map